import { useState, useEffect } from "react";
import { Battery, MapPin, Zap, Download, Eye } from "lucide-react";
import { Button } from "../ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../components/ui/carousel";

import { FaWhatsapp } from "react-icons/fa";
import Sidebar from "../Sidebar/sidebar";
import "./mob-on.css";

import logoMobon from "../../Assets/logo-mobon.png";
import comoUsarImg from "../../Assets/como-usar.png";
import eletroposto1 from "../../Assets/volvo-abastecendo.jpeg";
import eletroposto2 from "../../Assets/eletroposto-2.png";
import eletroposto4 from "../../Assets/eletroposto-4.png";
import eletroposto5 from "../../Assets/eletroposto-5.png";
import eletroposto6 from "../../Assets/bomba-abastecimento-mob-on.png";
import eletroposto7 from "../../Assets/mob-on-posto.png";
import eletroposto8 from "../../Assets/vista-frontal-eletroposto.jpeg";
import eletroposto9 from "../../Assets/vista-isometrica-eletroposto.jpeg";
import localImg from "../../Assets/local-1.png";
import dmcVideo from "../../Assets/dmc-video-atualizado.mp4";
import dmcSolarImg from "../../Assets/img-dmc-energia-solar.jpeg";

import { RiWhatsappFill } from "react-icons/ri";

export default function MobOn() {
  const [showInstructions, setShowInstructions] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  // mantém o espaço da sidebar (40px) no desktop
  useEffect(() => {
    const cls = "mobon-with-sidebar--collapsed";
    document.body.classList.add(cls);
    return () => document.body.classList.remove(cls);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll(); // seta o estado correto na carga
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const galleryImages = [
    { src: eletroposto1, alt: "" },
    { src: eletroposto2, alt: "" },
    { src: eletroposto4, alt: "" },
    { src: eletroposto5, alt: "" },
    { src: eletroposto6, alt: "" },
    { src: eletroposto7, alt: "" },
    { src: eletroposto8, alt: "" },
    { src: eletroposto9, alt: "" },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleDownloadPDF = () => {
    const a = document.createElement("a");
    a.href = "/passo-a-passo.pdf";
    a.download = "Passo_a_passo_MOB-ON.pdf";
    a.click();
  };

  const handleViewRoute = () => {
    window.open(
      "https://www.google.com/maps/dir/?api=1&destination=-20.895615,-47.6004",
      "_blank",
    );
  };

  return (
    <>
      {/* HEADER fixo (sem sanduíche) */}
      <header
        className={`mobon-topbar ${scrolled ? "mobon-topbar--scrolled" : ""}`}
      >
        <div className="mobon-topbar__wrap">
          <div className="topbar__brand">
            <Battery className="topbar__icon" />
            <span className="topbar__title">MOB-ON Eletroposto</span>
          </div>
        </div>
      </header>

      {/* SIDEBAR fixa (colapsada) */}
      <Sidebar open={false} onNavigate={(id) => scrollTo(id)} />

      <main className="mob-on-container">
        {/* HERO */}
        <section id="hero" className="mob-on-hero">
          <div className="container hero__container">
            <div className="hero__logo-card">
              <img
                src={logoMobon}
                alt="MOB-ON Eletroposto"
                className="hero__logo"
              />
            </div>

            <h1 className="hero__title">
              Bem-vindo ao <span className="text-primary">MOB-ON</span>
            </h1>

            <div className="hero__field">
              <p className="hero__subtitle">Eletroposto em Batatais</p>
              <p className="hero__subtitle">
                Carregamento rápido e sustentável para seu veículo elétrico
              </p>
            </div>

            <div className="hero-actions">
              <Button
                size="lg"
                variant="hero"
                onClick={() => scrollTo("como-usar")}
                className="hero-btn"
              >
                <Zap className="btn__icon" /> Como Usar
              </Button>

              <Button
                size="lg"
                variant="accent"
                onClick={() => scrollTo("localizacao")}
                className="hero-btn"
              >
                <MapPin className="btn__icon" /> Ver Localização
              </Button>
            </div>

            <div className="features">
              <div className="mob-on-feature-card">
                <Battery className="feature__icon" />
                <h3 className="feature__title">Carregamento Rápido</h3>
                <p className="feature__desc">
                  Tecnologia avançada para seu veículo
                </p>
              </div>
              <div className="mob-on-feature-card">
                <Zap className="feature__icon" />
                <h3 className="feature__title">Sustentável</h3>
                <p className="feature__desc">Energia limpa e renovável</p>
              </div>
              <div className="mob-on-feature-card">
                <MapPin className="feature__icon" />
                <h3 className="feature__title">Localização Estratégica</h3>
                <p className="feature__desc">Fácil acesso em Batatais</p>
              </div>
            </div>
          </div>
        </section>

        {/* COMO USAR */}
        <section id="como-usar" className="mob-on-how-to-section">
          <div className="container">
            <div className="howto">
              <div className="howto__head">
                <h2 className="howto__title">
                  Como Usar o <span className="text-primary">Carregador</span>
                </h2>
                <p className="howto__subtitle">
                  Siga nosso guia passo a passo para carregar seu veículo
                  elétrico de forma rápida e segura
                </p>
              </div>

              <div className="mob-on-instruction-card">
                {!showInstructions ? (
                  <div className="howto__closed">
                    <div className="mob-on-icon-circle">
                      <Eye className="howto__eye" />
                    </div>
                    <h3 className="howto__cta-title">Visualizar Instruções</h3>
                    <p className="howto__cta-desc">
                      Clique no botão abaixo para visualizar o passo a passo
                      completo de como usar nosso carregador
                    </p>

                    <div className="howto__actions">
                      <Button
                        size="lg"
                        variant="hero"
                        onClick={() => setShowInstructions(true)}
                      >
                        <Eye className="btn__icon" /> Visualizar Instruções
                      </Button>
                    </div>

                    <div className="howto__divider">
                      <Button
                        size="lg"
                        variant="accent"
                        className="hero-btn howto__pdf"
                        onClick={handleDownloadPDF}
                      >
                        <Download className="btn__icon" /> Ou baixe o PDF
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="howto__open">
                    <img
                      className="howto__image"
                      src={comoUsarImg}
                      alt="Como usar o carregador"
                    />
                    <div className="howto__actions">
                      <Button
                        size="lg"
                        variant="accent"
                        onClick={handleDownloadPDF}
                      >
                        <Download className="btn__icon" /> Baixar PDF
                      </Button>
                      <Button
                        size="lg"
                        variant="secondary"
                        onClick={() => setShowInstructions(false)}
                      >
                        Ocultar
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* GALERIA */}
        <section id="galeria" className="gallery">
          <div className="container">
            <div className="gallery__head">
              <h2 className="gallery__title">
                Conheça Nosso <span className="text-primary">Eletroposto</span>
              </h2>
              <p className="gallery__subtitle">
                Instalações modernas e seguras para carregar seu veículo
                elétrico com rapidez e eficiência
              </p>
            </div>

            {/* destaque */}
            <div className="mob-on-gallery-featured">
              <img
                src={galleryImages[selectedImage].src}
                alt={galleryImages[selectedImage].alt}
              />
              <div className="gallery__legend">
                <p className="gallery__legend-text">
                  {galleryImages[selectedImage].alt}
                </p>
                <div className="mob-on-gallery-indicators">
                  {galleryImages.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setSelectedImage(i)}
                      className={`mob-on-gallery-indicator ${
                        i === selectedImage ? "active" : "inactive"
                      }`}
                      aria-label={`Ver imagem ${i + 1}`}
                      type="button"
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* thumbs */}
            <div className="mobon-thumbs">
              <Carousel
                className="thumbs"
                value={selectedImage}
                onChange={setSelectedImage}
                length={galleryImages.length}
              >
                <CarouselContent className="thumbs__track">
                  {galleryImages.map((img, i) => (
                    <CarouselItem key={i} className="thumbs__item">
                      <button
                        onClick={() => setSelectedImage(i)}
                        className={`mob-on-thumbnail ${
                          selectedImage === i ? "active" : ""
                        }`}
                        type="button"
                      >
                        <img src={img.src} alt={img.alt} />
                        {selectedImage === i && (
                          <div className="mob-on-thumbnail-badge">
                            <div className="mob-on-thumbnail-pulse" />
                          </div>
                        )}
                      </button>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="thumbs__prev" />
                <CarouselNext className="thumbs__next" />
              </Carousel>
            </div>

            {/* stats */}
            <div className="stats">
              <div className="mob-on-stat-card">
                <div className="stats__value">100%</div>
                <p className="stats__label">Energia Limpa</p>
              </div>
              <div className="mob-on-stat-card">
                <div className="stats__value">24/7</div>
                <p className="stats__label">Disponibilidade</p>
              </div>
              <div className="mob-on-stat-card">
                <div className="stats__value">Rápido</div>
                <p className="stats__label">Carregamento</p>
              </div>
            </div>
          </div>
        </section>

        {/* LOCALIZAÇÃO */}
        <section id="localizacao" className="location">
          <div className="container">
            <div className="location__head">
              <h2 className="location__title">
                Nossa <span className="text-primary">Localização</span>
              </h2>
              <p className="location__subtitle">
                Visite-nos em Batatais e experimente a mobilidade elétrica
              </p>
            </div>

            <div className="location__content">
              <div className="location__card">
                <div className="location__row">
                  <div className="location__cta">
                    <Button size="lg" variant="hero" onClick={handleViewRoute}>
                      <MapPin className="btn__icon" /> Ver Rotas no Google Maps
                    </Button>
                  </div>
                </div>

                <div
                  className="mob-on-map-container"
                  onClick={handleViewRoute}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && handleViewRoute()}
                >
                  <img
                    src={localImg}
                    alt="Localização MOB-ON"
                    className="location__image"
                  />
                  <div className="mob-on-map-overlay">
                    <div className="location__overlay-text">
                      <MapPin className="location__overlay-pin" />
                      <p>Clique para abrir rotas</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="location__grid">
                <div className="location__smallcard">
                  <h3>Contato</h3>
                  <p className="text-muted-foreground">
                    Entre em contato para mais informações sobre nossos
                    serviços.
                    <br />
                    Atendimento 24h.
                  </p>
                </div>

                <div className="location__smallcard">
                  <h3>Suporte</h3>
                  <p className="text-muted-foreground">
                    Estamos aqui para ajudar com qualquer dúvida sobre
                    carregamento.
                    <br />
                    Atendimento 24h.
                  </p>
                </div>

                {/* Botão WhatsApp */}
                <div className="mt-4">
                  <Button asChild size="lg" variant="hero" className="hero-btn">
                    <a
                      href={`https://wa.me/5516991458575?text=${encodeURIComponent(
                        "Olá! Acabei de visitar o site da Mob-On e gostaria de mais informações.",
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Falar no WhatsApp"
                      className="mobon-whats-btn"
                    >
                      <FaWhatsapp
                        className="mobon-whats-icon"
                        aria-hidden="true"
                      />
                      <span>Estamos on-line</span>
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divulgação Energia Solar (DMC) */}
        <section className="dmc-solar">
          <div className="container">
            <div className="dmc-solar__card">
              <div className="dmc-solar__mediaGrid">
                {/* IMAGEM */}
                <div className="dmc-solar__media">
                  <img
                    src={dmcSolarImg}
                    alt="DMC Energia Solar"
                    className="dmc-solar__img"
                    loading="lazy"
                  />
                </div>

                {/* VÍDEO */}
                <div className="dmc-solar__media">
                  <video
                    className="dmc-solar__video"
                    src={dmcVideo}
                    controls
                    preload="metadata"
                    playsInline
                  />
                </div>
              </div>

              {/* TEXTO / CTA */}
              <div className="dmc-solar__content">
                <h3 className="dmc-solar__title">
                  Agora também com Energia Solar ☀️
                </h3>
                <p className="dmc-solar__desc">
                  O mesmo grupo do MOB-ON também atua com soluções em energia
                  solar. Economize na conta de luz com um projeto sob medida
                  para sua casa ou empresa.
                </p>

                <Button
                  asChild
                  size="lg"
                  variant="hero"
                  className="hero-btn dmc-solar__cta"
                >
                  <a
                    href={`https://wa.me/5516991458575?text=${encodeURIComponent(
                      "Olá! Vi no site do MOB-ON que vocês também trabalham com Energia Solar. Gostaria de um orçamento.",
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="dmc-solar__ctaLink"
                  >
                    <FaWhatsapp
                      className="mobon-whats-icon"
                      aria-hidden="true"
                    />
                    <span>Clique aqui e faça seu orçamento</span>
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer id="footer" className="mob-on-footer">
          <div className="container footer__container">
            <Battery className="footer__icon" />
            <h3 className="footer__title">MOB-ON Eletroposto</h3>
            <p className="footer__text">
              Batatais Eletromobilidade – Comprometidos com um futuro
              sustentável através da mobilidade elétrica.
            </p>
            <div className="mob-on-footer-divider">
              <p className="footer__copy">
                © {new Date().getFullYear()} MOB-ON Eletroposto. Todos os
                direitos reservados.
              </p>
            </div>
          </div>

          <a
            className="footer-partner partner-whats whats-link"
            href={`https://wa.me/5516991458575?text=${encodeURIComponent(
              "Olá, gostaria de informações sobre criação de sites e Tráfego Pago...",
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Solicitar orçamento pelo WhatsApp"
            role="button"
          >
            <RiWhatsappFill className="whats-icon" aria-hidden="true" />
            <span className="partner-text">
              Desenvolvido por: LD Web Sites e Tráfego Pago
            </span>
          </a>
        </footer>
      </main>
    </>
  );
}
